import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'PUT_CRAFT_TEMPLATE',
    method: 'PUT',
  });
  useEffect(() => {
    if (param&&param.id){
      exec({
        url: `/api/craft/templates/${param.id}`,
        data:param
      });
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [exec,isRequestSuccessed];
});
